import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Message, Paragraph } from '../../../../../shared/components';
import { useAppSelector } from '../../../../../shared/hooks/useAppDispatch';
import { DifferentiationsOverviewWrapper } from '../../../Differentiation/Atoms';
import PageBlocks from './Clustering/Components/PageBlocks';

type Props = {
  bookId: string;
};

export const PageManagementSidebarContentNew: FC<Props> = ({ bookId }) => {
  // hooks
  const { t } = useTranslation();
  // redux
  const blocks = useAppSelector((state) => state.blocks.blocks);
  const viewMode = useAppSelector((state) => state.trajectories.viewMode);
  const currentPageId = useAppSelector((state) => state.trajectories.currentPageId);

  return currentPageId != null ? (
    <DifferentiationsOverviewWrapper>
      <Paragraph>{t('trajectory.sidebar.pageManagement.intro')}</Paragraph>
      {viewMode === 'read' && (
        <Message type="info">
          Klik op de knop TRAJECTINHOUD AANPASSEN om de volgorde te wijzigen
        </Message>
      )}
      {viewMode === 'edit' && blocks && blocks.length > 0 && (
        <PageBlocks bookId={bookId} pageId={currentPageId} pageBlocks={blocks} />
      )}
    </DifferentiationsOverviewWrapper>
  ) : null;
};

export default PageManagementSidebarContentNew;
